import { render, staticRenderFns } from "./DishItem.vue?vue&type=template&id=64dadee3&scoped=true&"
import script from "./DishItem.vue?vue&type=script&lang=js&"
export * from "./DishItem.vue?vue&type=script&lang=js&"
import style0 from "./DishItem.vue?vue&type=style&index=0&id=64dadee3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dadee3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardTitle,VImg})
